import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/pages/home/instructors/Instructors.js");
